import InspectionCopyRequestButton from './InspectionCopyRequestButton';

export default InspectionCopyRequestButton;
